import { TranslateService } from "@ngx-translate/core";

// @dynamic
export class DataTableTranslateHelper {
  static TranslatorInstance: TranslateService;
}
